<template>
  <div class="sourcesPage">
    <div class="background"></div>
    <div class="sourcesBox">
      <h1>{{ t("title") }}</h1>
      <div class="sources">
        <ul class="courses">
          <h3>{{ t("courseSources") }}</h3>
          <li v-for="(course, index) in courses" :key="index">
            {{ course.name }}:
            <b>{{ course.pictureSource }}</b>
          </li>
        </ul>
        <ul class="tests">
          <h3>{{ t("testSources") }}</h3>
          <li v-for="(test, index) in tests" :key="index">
            {{ test.name }}:
            <b>{{ test.pictureSource }}</b>
          </li>
        </ul>
        <ul class="tasks">
          <h3>{{ t("taskSources") }}</h3>
          <li v-for="(testItem, index) in testItems" :key="index">
            {{ t("task") }}:{{ index + 1 }}:
            <b>{{ testItem.pictureSource }}</b>
          </li>
        </ul>
      </div>
      <button @click="goToResultPage">{{ t("result") }}</button>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local"
    });
    return { t };
  },

  methods: {
    goToResultPage() {
      this.$router.replace({ name: "result" });
    }
  },

  created() {
    this.$store.dispatch("resetTestChoice");
  },

  computed: {
    courses() {
      return this.$store.state.courses;
    },
    tests() {
      return this.$store.state.tests;
    },
    testItems() {
      return this.$store.state.testItems;
    }
  }
};
</script>

<i18n>
{
  "en-GB": {
    "title": "Sources",
    "courseSources":"Sources of the imgages used for the courses.",
    "testSources":"Sources of the images used for the tests.",
    "taskSources":"Sources for the images used in the tasks.",
    "result":"Result",
    "task": "Task"
  },
  "nl-NL": {
    "title": "Bronnen",
    "courseSources":"Bronnen van de afbeeldingen die zijn gebruikt voor de cursussen.",
    "testSources":"Bronnen van de afbeeldingen die voor de tests zijn gebruikt.",
    "taskSources":"Bronnen voor de afbeeldingen die in de taken worden gebruikt.",
    "result":"Resultaat",
    "task": "Taak"
  }
}
</i18n>

<style scoped>
.sourcesPage {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;
}

.background {
  background-image: url("https://phoenix-engineering.be/wp-content/uploads/2019/07/shutterstock_1113165392.png");
  background-size: cover;
  background-position: unset;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: blur(3px);
  -webkit-filter: blur(3px);
  z-index: -1;
}
.sourcesBox {
  margin-top: 30px;
  background-color: rgb(41, 41, 42);
  margin-bottom: 30px;
  box-shadow: 0 0px 5px 0px rgb(114, 108, 109);
  width: 85%;
  border: 30px solid rgb(41, 41, 42);
}
.sources {
  display: flex;
  justify-content: stretch;
}
h1 {
  font-size: 37px;
  background-color: rgb(41, 41, 42);
  color: white;
  margin: 0;
  padding: 0px;

  text-align: center;
}

h3 {
  font-size: 20px;
  background-color: rgb(87, 87, 87);
  color: white;
  margin: 0;
  padding: 13px;
  text-align: center;
}
ul {
  list-style: none;
  padding: 0;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 30px;
  margin-right: 0px;
}

.courses {
  width: 33.333%;
  margin-left: 0px;
}
.tests {
  width: 33.333%;
}
.tasks {
  width: 33.333%;
}

li {
  font-size: 15px;
  margin-bottom: 25px;
  padding: 15px;
  margin: 0px;
  border: 3px solid rgb(87, 87, 87);
  margin-top: -3px;
  background-color: rgb(163, 163, 163);
}

button {
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 20px 50px;

  font-family: "Raleway", sans-serif;
  letter-spacing: 1.5px;

  padding: 25px 40px;
  background-color: rgb(165, 0, 41);

  color: rgb(255, 255, 255);
  border-style: none;

  font-size: 20px;
  cursor: pointer;
}
button:hover {
  transform: scale(1.03);
}

@media screen and (max-width: 1300px) {
  .sourcesBox {
    width: 90%;
    border: 20px solid rgb(41, 41, 42);
  }
  h1 {
    font-size: 30px;
  }
  h3 {
    font-size: 18px;
  }

  ul {
    margin-left: 20px;
  }
  .courses {
    margin-left: 0px;
  }

  button {
    margin-top: 20px;
    margin-bottom: 20px;

    padding: 20px 35px;
    background-color: rgb(165, 0, 41);

    font-size: 18px;
  }
}

@media screen and (max-width: 800px) {
  .sourcesBox {
    width: 90%;
    border: 20px solid rgb(41, 41, 42);
  }
  .sources {
    flex-direction: column;

    align-items: center;
  }
  li {
    font-size: 13px;
  }
  ul {
    list-style: none;
    padding: 0;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .courses {
    width: 80%;
    margin-left: 10px;
  }
  .tests {
    width: 80%;
  }
  .tasks {
    width: 80%;
  }
}
@media screen and (max-width: 600px) {
  .sourcesBox {
    width: 100%;
    border: 0px solid rgb(41, 41, 42);
    margin: 0px;
  }
  h1 {
    margin-top: 30px;
  }
  ul {
    margin-left: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
  .courses {
    width: 90%;
    margin-left: 0px;
  }
  .tests {
    width: 90%;
  }
  .tasks {
    width: 90%;
  }
  button {
    padding: 20px 35px;
    font-size: 15px;
  }
}
</style>